  <nav class="navbar navbar-expand-md fixed-top flex-fill">
    <!-- <div class="navbar-header pl-2 pr-2 ml-3">
      <a class="navbar-brand m-0 w-100">
        <span class="ml-1"> 
               <img src="./assets/images/EurolandLogo2.png" alt="EurolandCom Logo" style="width: 14rem!important;filter: brightness(1.5)!important;">
        </span>
      </a>
    </div> -->
    <!-- sidebar toggler -->
    <!-- <div class="sidebar-toggler ml-auto mr-3">
      <a class="btn nav-link" (click)="toggleSidebar()"><i class="fa fa-bars"></i></a>
    </div> -->
    <!-- right menu toggler -->
    <!-- <div class="nav-toggler-right mr-4 d-md-none">
      <button class="" type="button" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed"
        aria-controls="collapseBasic">
        <img src="./assets/images/user.jpg" class="img-fluid" alt="">
      </button>
      <span class="user-profile nav-alert bg-danger"></span>
    </div> -->
    <!-- left box -->
    <ul class="navbar-nav flex-fill mt-1 ml-5 align-items-center left-nav">
      <!-- <li class="nav-item navicon">
        <a class="btn nav-link" (click)="toggleSidebarPin()"><i class="fa fa-bars"></i></a>
      </li> -->
      <li class="nav-item flex-fill align-items-center">
        <span class="siteName">{{"Sitetitle" | translate}}</span>
      </li>
    </ul>
    <!-- user Name -->
    <div class="userName">
      {{"Welcome" | translate}}, {{user.firstName}} !
    </div>
    <!-- right menu -->
    <div class="collapse navbar-collapse d-flex justify-content-end" id="collapseBasic" [collapse]="isCollapsed">
      <ul class="navbar-nav d-flex align-items-center">
        <span class="form-inline mr-2">
          <select class="form-control" #selectedLang (change)="switchLang(selectedLang.value)">
            <option *ngFor="let language of this.language" [value]="language"
              [selected]="language === this.currentLang">
              <span *ngIf="language==='sv'">Swedish</span>
              <span *ngIf="language==='en'">English</span>
            </option>
            <!-- {{ "English" | translate}}
            {{"Swedish" | translate}} -->

          </select>
        </span>
        <li class="nav-item changePwd mr-2">
          <button class="btn btn-primary" data-toggle="modal" data-target="#changePasswordModal" data-keyboard="false"
            data-backdrop="static" (click)="this.autoFocusFn()">
            <i class="fa fa-lock"></i> {{"Change-my-password" | translate}}
          </button>
        </li>
        <li class="nav-item logOut mr-2">
          <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#logoutModal"
            data-keyboard="false" data-backdrop="static" (click)="this.autoFocusStayFn()">
            <i class="fas fa-sign-out-alt"></i> {{"Logout" | translate}}</button>
        </li>
        <li class="nav-item logOut mr-4" [hidden]="this.user.role == 'shareholder'">
          <app-notify (openChat)="chatCall($event)" #notify></app-notify>
        </li>
      </ul>
    </div>
  </nav>

  <!-- Modal -->
  <div class="modal fade" #changePasswordModal id="changePasswordModal" tabindex="-1" role="dialog"
    aria-labelledby="changePasswordModal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document" style="min-width: fit-content;">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title" id="changePasswordModalTitle">{{"Change-Password" | translate}}</div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModalFn()"
            #closeBtn>
            <i class="fa fa-times-circle fa-2x whiteColor" aria-hidden="true"></i>
          </button>
        </div>
        <div class="modal-body modalBody">
          <form action="#!" [formGroup]="passwordForm">
            <div class="form-group">
              <label for="password dangerAstrick">{{"Current-Password" | translate}}</label>
              <div class="input-group">
                <input [type]="fieldTextType1 ? 'text' : 'password'" name="currentPassword" #firstElement 
                  formControlName="currentPassword" id="currentPassword" class="form-control iconAdd"
                  placeholder="***********" [ngClass]="{ 'is-invalid': submitted && f?.currentPassword.errors }">
                <div class="input-group-append">
                  <span class="input-group-text iconBorder hoverCursor" (click)="toggleFieldTextType(1)">
                    <i class="fa" [ngClass]="{
                  'fa-eye-slash': !fieldTextType1,
                  'fa-eye': fieldTextType1
                }"></i>
                  </span>
                </div>
                <div *ngIf="submitted && f?.currentPassword.errors" class="invalid-feedback">
                  <div *ngIf="f?.currentPassword.errors.required">{{"Current-Password" | translate}}
                    {{"Required" | translate}}</div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="password dangerAstrick">{{"New-Password" | translate}}</label>
              <div class="input-group">
                <input [type]="fieldTextType2 ? 'text' : 'password'" name="newPassword" formControlName="newPassword"
                  id="newPassword" class="form-control iconAdd" placeholder="***********"
                  [ngClass]="{ 'is-invalid': submitted && f?.newPassword.errors }">
                <div class="input-group-append">
                  <span class="input-group-text iconBorder hoverCursor" (click)="toggleFieldTextType(2)">
                    <i class="fa" [ngClass]="{
                'fa-eye-slash': !fieldTextType2,
                'fa-eye': fieldTextType2
              }"></i>
                  </span>
                </div>
                <div *ngIf="submitted && f?.newPassword.errors" class="invalid-feedback">
                  <div *ngIf="f?.newPassword.errors.required">{{"New-Password" | translate}} {{"Required" | translate}}
                  </div>
                  <div *ngIf="f?.newPassword.errors.minlength">Password must be at least 6 characters</div>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="password dangerAstrick">{{"Confirm-New-Password" | translate}}</label>
              <div class="input-group">
                <input [type]="fieldTextType3 ? 'text' : 'password'" name="confirmPassword"
                  formControlName="confirmPassword" id="confirmPassword" class="form-control iconAdd"
                  placeholder="***********" [ngClass]="{ 'is-invalid': submitted && f?.confirmPassword.errors }">
                <div class="input-group-append">
                  <span class="input-group-text iconBorder hoverCursor" (click)="toggleFieldTextType(3)">
                    <i class="fa" [ngClass]="{
              'fa-eye-slash': !fieldTextType3,
              'fa-eye': fieldTextType3
            }"></i>
                  </span>
                </div>
                <div *ngIf="submitted && f?.confirmPassword.errors" class="invalid-feedback">
                  <div *ngIf="f?.confirmPassword.errors.required">{{"Confirm-New-Password" | translate}}
                    {{"Required" | translate}}</div>
                  <div *ngIf="f?.confirmPassword.errors.mustMatch">Passwords must match</div>
                </div>
              </div>
            </div>
            <hr>
            <button type="submit" class="btn btn-primary float-right" appDebounceClick
            (debounceClick)="resetPassword()">{{"Reset" | translate}}</button>

            <!-- <input name="passwordChange" id="passwordChange" class="btn btn-block login-btn mt-4 mb-4" type="submit" value="passwordChange"  (keyup.enter)="onSubmit()"> -->
            <!-- <button type="submit" (keyup.enter)="onSubmit()"></button> -->
          </form>
        </div>
        <!-- <div class="modal-footer">
      <button type="submit" class="btn btn-primary btn-send" (click)="resetPassword()">Reset</button>
    </div> -->
      </div>
    </div>
  </div>

  <!--Logout Modal -->
  <div class="modal fade" #logoutModal id="logoutModal" tabindex="-1" role="dialog" aria-labelledby="logoutModalTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document"  style="max-width: 25rem;">
      <div class="modal-content">
        <div class="modal-header">
          <h5 id="ModalTitle">{{"Are-you-sure" | translate}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalClose()" #closeBtn2>
          </button>
        </div>
        <!-- <div class="modal-body modalBody euroFont">
          <div class="container">
            <p>{{"Do-you-want-to-logout" | translate}}!</p>
          </div>
        </div> -->
        <div class="modal-footer">
          <button type="submit" class="btn stay-button" (click)="modalClose()" #stay translate>Cancel</button>
          <button type="submit" class="btn btn-danger" (click)="logOut()">{{"Logout" | translate}}!</button>
        </div>
      </div>
    </div>
  </div>
